import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  OnInit,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PORTAL_ROUTE_NAMES } from '@app/modules/portal/portal.routes.names';

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FeedbackDialogComponent implements OnInit {
  modalColor = this.data.data.color;
  modalMsg = this.data.data.message;
  protocolNumber = this.data.data.protocolNumber;
  anualBalance = this.data.data.anualBalance;
  staticTemplateMessage = this.data.data.message;
  showCloseButton = this.data.data.showCloseButton ?? true;

  constructor(
    public dialogRef: MatDialogRef<FeedbackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.dialogRef.updateSize('760px');
    this.dialogRef.updatePosition({ top: '50px' });

    if (this.anualBalance?.length > 0) {
      this.generateText(0);
    }
  }

  modalColors = [
    {
      title: 'warning',
      value: 1,
    },
    {
      title: 'success',
      value: 2,
    },
    {
      title: 'info',
      value: 3,
    },
    {
      title: 'error',
      value: 4,
    },
  ];

  @Output() closeClick = new EventEmitter<void>();

  @Input() closeButtonText = 'Fechar';

  @Input() submitButtonText = 'Salvar';

  onCloseClick = () => this.closeClick.emit();

  get trackRequestsLink() {
    return `/${PORTAL_ROUTE_NAMES.TRACK_REQUESTS}`;
  }
  get dashboardLink() {
    return `/${PORTAL_ROUTE_NAMES.DASHBOARD}`;
  }

  generateText(position: number, event = null) {
    if (event != null) {
      for (let i = 0; i < this.anualBalance.length; i++) {
        let btn = document.getElementById('btnbalance' + i);
        btn.classList.remove('clicked');
      }
      event.target.classList.add('clicked');
    } else {
      setTimeout(() => {
        let btn = document.getElementById('btnbalance0');
        btn.classList.add('clicked');
      }, 200);
    }

    let valores = '';
    for (let i = 0; i < this.anualBalance[position].balance.values.length; i++) {
      valores += this.anualBalance[position].balance.values[i] + '<br>';
    }
    this.modalMsg = this.staticTemplateMessage
      .replace('{propostas}', this.anualBalance[position].balance.proposals)
      .replace('{ano}', this.anualBalance[position].year.toString())
      .replace('{ano2}', this.anualBalance[position].year.toString())
      .replace('{valor}', valores);
  }

  closeDialog() {
    this.dialogRef.close();
    if (this.data.data.reload) {
      location.reload();
    }
  }
}
